import { createRoot } from "react-dom/client";
import { Provider as RollbarProvider, ErrorBoundary } from "@rollbar/react";
import App from "./App.tsx";
import { AuthProvider } from "@/context/AuthContext";
import "./index.css";


const rollbarConfig = {
  accessToken: "263cf552d0724e448c4e8552023141e5573deaf09fde412cb7891f9ce18e92f8daa8fa5ebad0f1acf060f66db13ff17b",
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: import.meta.env.MODE,
  payload: {
    client: {
      javascript: {
        code_version: __CODE_VERSION__,
        source_map_enabled: true,
      },
    },
  },
};

createRoot(document.getElementById("root")!).render(
  <RollbarProvider config={rollbarConfig}>
    <ErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </RollbarProvider>
);
